export const goToAddress = (address) => {
  window.open(address, "_blank");
};
